const walkInJobs = [
    { id: 1,
      title: "Backend Developer",
      date: "2025-04-25",
      location: "Delhi",
      experience: "2years",
      description:"want a full stack developer"
    },
   
    { id: 2,
      title: "Frontend Developer",
      date: "2025-04-25",
      location: "Bangalore",
      experience: "5years",
      description:"want a full stack developer"
    },
   
   
    { id: 3,
      title: "Frontend Developer",
      date: "2025-04-25",
      location: "Bangalore",
      experience: "3syears",
      description:"want a full stack developer"
    },
   
    { id: 4,
      title: "Frontend Developer",
      date: "2025-04-25",
      location: "Bangalore",
      experience: "5years",
      description:"want a full stack developer"
    },
   
   
  ];
   
  export default walkInJobs;